module.exports = __webpack_public_path__ + "static/img/record-hour.99312b79.png";